import React from "react";
import { useSelector } from "react-redux";

const Spinner = () => {
  const { isGettingUser } = useSelector((state) => state.User);
  if (isGettingUser) {
    return (
      <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[999]">
        <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
        <div
          className="animate-spin inline-block w-10 h-10 border-[3px] border-current border-t-transparent text-yellow-1000 rounded-full absolute text-5xl text-white"
          role="status"
          aria-label="loading"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
};

export default Spinner;
